import React from 'react'
import styled from 'styled-components'

import { ModalProps } from '../../../components/bakery/Modal'

const ImgDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow-y: scroll;
  background: rgba(23, 20, 18, 0.9);
`
const ImgTable = styled.div`
  display: table;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`
const ImgCell = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
`
const ImgCurImg = styled.div`
  margin: 0 auto;
  width: 700px;
  height: 700px;
  line-height: 700px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 80%;
    height: auto;
  `}
`
const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 18px;
  object-fit: contain;
  cursor: pointer;
  overflow: hidden;
  vertical-align: middle;
`

interface ImgModalProps extends ModalProps {
  url: string
}
const ImageBig: React.FC<ImgModalProps> = ({
  onDismiss,
  url
}) => {
  return (
    <ImgDiv onClick={onDismiss}>
      <ImgTable>
        <ImgCell>
          <ImgCurImg>
            <Img src={url} alt=""></Img>
          </ImgCurImg>
        </ImgCell>
      </ImgTable>
    </ImgDiv>
  )
}

export default ImageBig
